// extracted by mini-css-extract-plugin
module.exports = {"displayLinebreak":"equal-employment-opportunity_displayLinebreak__1xgLI"};